import React from 'react';
import { Progress } from '@landr/maestro';
import { Section } from 'components/Section/Section';

/**
 * We need a slide that render a Progress component
 * Until we know if we have to render the HeroWelcome or not
 */

const LoadingHero = () => {
    return (
        <Section>
            <Section.Content contentPosition="center">
                <Progress size="lg" />
            </Section.Content>
        </Section>
    );
};

export default LoadingHero;
